// @flow

import React from 'react';

type EmptyFieldsMessageProps = {
  config: Object,
  field: Object,
  plain: string,
  className?: string,
};

const EmptyFieldsMessage = (props: EmptyFieldsMessageProps) => {
  return props.config.createElement(
    'field',
    {
      field: props.field,
      plain: props.plain,
      classes: { warn: props.field.required },
    },
    <div className="pretty-text-wrapper">
      <div className={`fm-prettytext fm-pretty-text-input pretty-text-box`}>
        {props.field.fields.map(field => field.label || field.key).join('\n')}
      </div>
    </div>
  );
};

export default EmptyFieldsMessage;
